module.exports = __webpack_public_path__ + "static/media/cricket.35bc039e.svg";